app.controller("StudentsSelectionStatesController", [
    "$scope", "Socket", "Selection", "Students", "StaticData", "ProgramService", "SysParam", "$stateParams", "$state", "$http", "$uibModal", "usSpinnerService",
    function ($scope, Socket, Selection, Students, StaticData, ProgramService, SysParam, $stateParams, $state, $http, $uibModal, usSpinnerService) {
        $scope.levelsMap = {};
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.level = $stateParams.level;
        $scope.state = $stateParams.state;
        $scope.faculty = $stateParams.faculty;
        $scope.selectionState = $stateParams.selectionState;
        $scope.semester = $stateParams.semester || 'სემესტრი';
        $scope.semesters = ['სემესტრი'].concat(_.range(1, 15));

        if ($stateParams.program) {
            ProgramService.fetchOne($stateParams.program).then(function (program) {
                $scope.program = program;
            });
        }

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };

        StaticData.getItemsByKey("sort_types").then(function (sortTypes) {
            $scope.sortTypes = sortTypes;
            $scope.sortTypesMap = _.keyBy($scope.sortTypes, '_id');
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        StaticData.getItemsByKey("student_selection_states").then(function (selectionStates) {
            $scope.selectionStates = [{name: "სტუდენტის მდგომარეობა"}].concat(selectionStates);
            $scope.selectionStatesMap = _.keyBy($scope.levels, '_id');
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                faculty: $scope.faculty,
                level: $scope.level,
                state: 'active',
                selectionState: $scope.selectionState,
                program: $scope.program ? $scope.program._id : undefined,
                semester: $scope.semester !== 'სემესტრი' ? $scope.semester : undefined
            });
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            Students.list({
                page: page,
                limit: $scope.itemsPerPage,
                query: $stateParams.query,
                faculty: $stateParams.faculty,
                level: $stateParams.level,
                state: 'active',
                selectionState: $stateParams.selectionState,
                program: $stateParams.program,
                semester: $stateParams.semester
            }).then(function (data) {
                var studentList = data.docs;
                for (var i in studentList) {
                    if (!studentList[i].user.photo && studentList[i].user.gender == 'male') studentList[i].user.defaultPhoto = "img/male.jpg";
                    if (!studentList[i].user.photo && studentList[i].user.gender == 'female') studentList[i].user.defaultPhoto = "img/female.jpg";
                    else if (!studentList[i].user.photo && !studentList[i].user.gender) studentList[i].user.defaultPhoto = "img/no_image.jpg";
                }
                $scope.students = studentList;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.edit = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditStudentController",
                templateUrl: _pb + 'admin/students/edit-student.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    student: function () {
                        return student;
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($scope.currentPage);
                }, function () {
                });
        };

        $scope.finances = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go("admin.studentPayments", {studentId: student._id, student: student});
        };

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });
    }
]);
